import { combine } from 'effector'
import { AuthTab, model as tabsModel } from '~/features/change-auth-type'
import { model as signInModel } from '~/features/subscriber/sign-in'

export const $isSignInByPhoneActivated = combine(
  signInModel.$signInWithPhoneEnabled,
  tabsModel.$selectedTab,
  (signInWithPhoneEnabled, selectedTab) =>
    signInWithPhoneEnabled && selectedTab === AuthTab.Phone
)

export const $isSignInByEmailActivated = combine(
  signInModel.$signInWithPhoneEnabled,
  tabsModel.$selectedTab,
  (signInWithPhoneEnabled, selectedTab) =>
    !signInWithPhoneEnabled || selectedTab === AuthTab.Email
)
